import { createGlobalStyle } from 'styled-components';
import { palette, font } from 'styled-theme';
// import 'antd/dist/antd.css';

const GlobalStyles = createGlobalStyle`
  .ant-btn{
    border-radius: 4px;
  }

  .ant-select-selector{
    height: auto !important;
  }

  .isoDropdownBody{
    //overflow-y: scroll;
    overflow-y: auto !important;
  }

  // .titleNotification .ant-input-affix-wrapper{
  //   border: none !important;
  // }.titleNotification .ant-input-affix-wrapper-focused{
  //   border-color: none !important;
  //   box-shadow: none !important;
  // }

  .rbc-time-gutter .rbc-timeslot-group div {
    background-color: unset !important;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headerCalendar{
    background-color: #fff;
    padding: 30px 30px;
    border-radius: 10px;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    border: 1px solid #e9e9e9;
    border-bottom-left-radius: unset;
    border-bottom-right-radius: unset;
    border-bottom: unset;
    border-bottom-color: unset;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .legend{
    display: flex;
    justify-content: start;
  }.legend p{
    margin-left: 10px;
  } 

  .operatorSelect{
    justify-content: end;
    display: flex;
    align-items: center;
  }

  .myCalendar{
    border-top-left-radius: unset !important;
    border-top-right-radius: unset !important;
    border-bottom: unset !important;
    border-top-color: transparent !important;
    padding-top: 0px !important;
  }

  .rbc-button-link {
    border: none;
    background-color: none !important;
    background: none;
    pointer-events: none;
  }

  .logo {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
  }

  /*** SETTO DIMENSIONI E POSIZIONE DEGLI EVENTI NEL CALENDARIO ***/
  .rbc-event{
    width: 100% !important;
    left: unset !important;
    right: unset !important;
  }

  .ant-row.ant-form-item {
    margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }

  /*** CLASSI PER LA PAGINA NOTIFICA ***/
  .notificationClass{
    border : unset !important;
    padding: 0 !important;
    background-color: unset !important;
  }

  .notificationClass .ant-table table{
    border-spacing: 10px !important;
  }

  .notificationClass thead.ant-table-thead {
    display: none;
  }

  .notificationClass .ant-table-wrapper {
    background-color: transparent !important;
  }

  .notificationClass .ant-table {
    background-color: transparent !important;
  }
  
  .notificationClass td.ant-table-cell {
    background-color: white !important;
    padding: 0 !important; 
  }
  
  /*-----------------------------------------------*/
  // style for project category menu [ScrumBoard]
  /*-----------------------------------------------*/
  .project-category {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item {
        padding: 8px 12px;
        color: #000000;
        font-family: 'Roboto';
        font-weight: 400;
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project menu [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-dropdown {
    &.project-menu {
      width: 280px;
      top: 133px !important;

      .ant-dropdown-menu {
        padding: 0;
        overflow: hidden;

        .ant-dropdown-menu-item {
          min-height: 54px;
          line-height: auto;
          display: flex;
          align-items: center;
          padding: 10px 20px;

          &:first-child {
            padding: 0;
            border-bottom: 1px solid #f4f6fd;

            &:hover,
            &:focus {
              background-color: #ffffff;
            }
          }

          &:hover,
          &:focus {
            background-color: #F3F5FD;
          }

          &:last-child {
            background-color: #E6EAF8;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for popover [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-popover {
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        margin: 5px 0;
        span {
          font-size: 14px;
          color: #788195;
          text-transform: capitalize;
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for modal [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .render-form-wrapper {
            padding: 10px;
            h2 {
              margin: 0;
            }
            form {
              padding: 15px 0 3px;
              .field-container {
                margin-bottom: 26px;
              }
            }
          }
        }
      }
    }
  }


/*-----------------------------------------------*/
  // style form previous GlobalStyles
  /*-----------------------------------------------*/

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
}

font-family: ${font('primary', 0)};

h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
li,
input,
textarea,
span,
div,
img,
svg {
  &::selection {
    background: ${palette('primary', 0)};
    color: #fff;
  }
}

.ant-row:not(.ant-form-item) {
  ${
    '' /* margin-left: -8px;
  margin-right: -8px; */
  };
  &:before,
  &:after {
    display: none;
  }
}

.ant-row > div {
  padding: 0;
}

.isoLeftRightComponent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.isoCenterComponent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/********** Add Your Global CSS Here **********/

body {
  -webkit-overflow-scrolling: touch;
}

html h1,
html h2,
html h3,
html h4,
html h5,
html h6,
html a,
html p,
html li,
input,
textarea,
span,
div,
html,
body,
html a {
  margin-bottom: 0;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
}

html ul {
  -webkit-padding-start: 0px;
  list-style: none;
  margin-bottom: 0;
}

.scrollbar-track-y,
.scrollbar-thumb-y {
  width: 5px !important;
}

.scrollbar-track-x,
.scrollbar-thumb-x {
  height: 5px !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
}

.scrollbar-track {
  background: rgba(222, 222, 222, 0.15) !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-bottomLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-bottomRight
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-topLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-topRight
  > .ant-popover-content
  > .ant-popover-arrow:after {
  left: 0;
  margin-left: -4px;
}

/* Instagram Modal */

.ant-modal-wrap.instagram-modal .ant-modal {
  max-width: 935px;
  width: 100% !important;
}

@media only screen and (max-width: 991px) {
  .ant-modal-wrap.instagram-modal .ant-modal {
    padding: 0 60px;
  }
}

@media only screen and (max-width: 767px) {
  .ant-modal-wrap.instagram-modal .ant-modal {
    max-width: 580px;
  }
}

.ant-modal-wrap.instagram-modal .ant-modal-content {
  border-radius: 0;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close {
  position: fixed;
  color: #fff;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close i {
  font-size: 24px;
}

.ant-modal-wrap.instagram-modal .ant-modal-content .ant-modal-body {
  padding: 0;
}

.rbc-current-time-indicator{
  background-color: unset !important;
}

/********** Add Your Global RTL CSS Here **********/

/* Popover */

html[dir='rtl'] .ant-popover {
  text-align: right;
}

/* Ecommerce Card */

html[dir='rtl'] .isoCardInfoForm .ant-input {
  text-align: right;
}

/* Modal */

html[dir='rtl'] .has-success.has-feedback:after,
html[dir='rtl'] .has-warning.has-feedback:after,
html[dir='rtl'] .has-error.has-feedback:after,
html[dir='rtl'] .is-validating.has-feedback:after {
  left: 0;
  right: auto;
}

html[dir='rtl'] .ant-modal-close {
  right: inherit;
  left: 0;
}

html[dir='rtl'] .ant-modal-footer {
  text-align: left;
}

html[dir='rtl'] .ant-modal-footer button + button {
  margin-left: 0;
  margin-right: 8px;
}

html[dir='rtl'] .ant-confirm-body .ant-confirm-content {
  margin-right: 42px;
}

html[dir='rtl'] .ant-btn > .anticon + span,
html[dir='rtl'] .ant-btn > span + .anticon {
  margin-right: 0.5em;
}

html[dir='rtl'] .ant-btn-loading span {
  margin-left: 0;
  margin-right: 0.5em;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {
  padding-left: 25px;
  padding-right: 29px;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)
  .anticon {
  margin-right: -14px;
  margin-left: 0;
}

/* Confirm */

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-body > .anticon {
  margin-left: 16px;
  margin-right: 0;
  float: right;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns {
  float: left;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns button + button {
  margin-right: 10px;
  margin-left: 0;
}

/* Message */

html[dir='rtl'] .ant-message .anticon {
  margin-left: 8px;
  margin-right: 0;
}

/* Pop Confirm */

html[dir='rtl'] .ant-popover-message-title {
  padding-right: 20px;
  padding-left: 0;
}

html[dir='rtl'] .ant-popover-buttons {
  text-align: left;
}

/* Notification */

html[dir='rtl']
  .ant-notification-notice-closable
  .ant-notification-notice-message {
  padding-left: 24px;
  padding-right: 0;
}

html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-message,
html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
  margin-right: 48px;
}

html[dir='rtl'] .ant-notification-notice-close {
  right: auto;
  left: 16px;
}

html[dir='rtl'] .ant-notification-notice-with-icon {
  left: 0;
}

/* Dropzone */

html[dir='rtl'] .dz-hidden-input {
  display: none;
}


/* REACT BIG CALENDAR - CUSTOM RULES */

div.rbc-events-container {
	pointer-events: none; /* così facendo facciamo il forward dell'evento all'elemento div.rbc-time-column */
}

div.rbc-events-container > div.rbc-event {
	pointer-events: all; /* in questo modo intercetto il click solo dove mi interessa, ossia sull'evento mostrato a calendario*/
}


.operatorInputGroup .ant-select.ant-select-single.ant-select-show-arrow{
  width: 100% !important;
}

.formreduceLoyaltyPointsButton{
  background-color: red;
}
.formreduceLoyaltyPointsButton:hover, 
.formreduceLoyaltyPointsButton:focus, 
.formreduceLoyaltyPointsButton:active{
  background-color: red !important;
  border-color: red !important;
}

.ant-spin-dot-item{
  background-color: #d0b8a7 !important;
}

.ant-btn {
  color: #d0b8a7;
  border-color: #d0b8a7;
}

.ant-btn:active {
  color: #d0b8a7;
  border-color: #d0b8a7;
}

.ant-btn:hover, .ant-btn:focus {
  color: #d0b8a7;
  border-color: #d0b8a7;
}

.ant-btn-primary{
  border-color: #d0b8a7;
  color: white;
  background-color: #d0b8a7;
}

.ant-btn-primary:hover, .ant-btn-primary:focus , .ant-btn-primary:active{
  border-color: #7d6e83 !important;
  background-color: #7d6e83 !important;
  color: white;
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled){
  background-color: #f7ede3 !important;
}

.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-color: #f7ede3 !important;
  box-shadow: 0 0 0 2px rgba(224 212 196 / 20%) !important;
}

.ant-select:not(.ant-select-disabled):hover .ant-select-selector{
  border-color: #e0d4c4 !important;
}

.ant-picker-today-btn{
  color: #d0b8a7 !important;
}

.ant-picker-today-btn:hover{
  color: #e0d4c4 !important;
}

.ant-picker-header-view button:hover{
  color: #e0d4c4 !important;
}

.ant-picker-focused{
  box-shadow: 0 0 0 2px rgba(224 212 196 / 20%) !important;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before{
  border-color: #d0b8a7 !important
}

.ant-input:focus, .ant-input-focused {
  border-color: #f7ede3 !important;
  box-shadow: 0 0 0 2px rgba(224 212 196 / 20%) !important;
}

.ant-input:hover{
  border-color: #f7ede3 !important;
}

.ant-checkbox-checked .ant-checkbox-inner{
  background-color: #d0b8a7 !important;
  border-color: #f7ede3 !important;
}

.ant-checkbox-checked::after{
  border: 1px solid rgba(224 212 196 / 20%) !important;
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner{
  border: 1px solid rgba(224 212 196 / 20%) !important;
}

.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon, .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon{
  color: #e0d4c4 !important;
}

.ant-pagination-prev:hover .ant-pagination-item-link, .ant-pagination-next:hover .ant-pagination-item-link{
  border-color: #d0b8a7 !important;
  color: #e0d4c4 !important;
}

.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover{
  border-color: #d0b8a7 !important;
  box-shadow: 0 0 0 2px rgba(224 212 196 / 20%) !important;
}

.ant-input-affix-wrapper:focus, .ant-input-affix-wrapper-focused{
  border-color: #d0b8a7 !important;
  box-shadow: 0 0 0 2px rgba(224 212 196 / 20%) !important;
}

.forgotPassword{
  color: #d0b8a7 !important;
}

.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner{
  background-color: #d0b8a7 !important;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner{
  background-color: #e0d4c4 !important;
}

a.ant-picker-now-btn {
  color: #d0b8a7 !important;
}

.ant-picker-focused{
  border-color: #d0b8a7 !important;
  box-shadow: 0 0 0 2px rgba(224 212 196 / 20%) !important;
}

.ant-picker-input > input:hover{
  border-color: #d0b8a7 !important;
}

.ant-picker:hover, .ant-picker-focused{
  border-color: #d0b8a7 !important;
}

.ant-switch-checked{
  background-color: #D0B8A7 !important;
}

.ant-input-number:hover{
  border-color: #d0b8a7 !important;
}

.ant-input-number:focus, .ant-input-number-focused{
  border-color: #d0b8a7 !important;
  box-shadow: 0 0 0 2px rgba(224 212 196 / 20%) !important;
}

.ant-input-number-handler:hover .ant-input-number-handler-up-inner, .ant-input-number-handler:hover .ant-input-number-handler-down-inner{
  color: #d0b8a7 !important;
}

.ant-checkbox-indeterminate .ant-checkbox-inner::after{
  background-color: #D0B8A7 !important;
}

.ant-picker-range .ant-picker-active-bar{
  background: #7d6e83 !important;
}

`;

export default GlobalStyles;
